<template>
  <div class="mediaCard-wrapper">
    <MediaCard
      id="extendingLifecycle"
      title="Wecobi extends the product life cycle and converts it into free marketing opportunities."
      subtitle="Deadstock accumulation is a common issue in traditional retail models where product value
declines over time, leading to inventory losses and waste. Convert your deadstock into valuable
marketing opportunities with Wecobi!"
      :imageSrc="imageOne"
    />
    <MediaCard
      id="abtesting"
      title="A/B testing"
      subtitle="Wecobi specializes in AB testing products and markets, allowing brands to gauge market response before full scale production, thus minimizing the risk of dead stock accumulation."
      :imageSrc="imageTwo"
      :reverse="true"
    />
    <MediaCard
      id="optimizedDiscounts"
      title="Why Wecobi Should Be Your First Point of Discount"
      subtitle="In today’s retail landscape, keeping consumer interest as products reach maturity is a significant
challenge, and premature discounting often leads to profit loss. Wecobi offers a solution as the
primary platform for strategic discounting, helping brands manage product decline while
preserving profitability."
      :imageSrc="imageThree"
    />
  </div>
</template>

<script>
import MediaCard from "../ReusableComponents/MediaCard.vue";
import WecobiExtends from "../../../assets/marketing/wecobi-extends.png";
import ABTesting from "../../../assets/marketing/ABtesting.png";
import FirstPoint from "../../../assets/marketing/first-point.png";

export default {
  components: {
    MediaCard,
  },
  data: function () {
    return {
      imageOne: WecobiExtends,
      imageTwo: ABTesting,
      imageThree: FirstPoint,
    };
  },
};
</script>
<style scoped>
.mediaCard-wrapper {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
